import { quantityAddCommas } from 'sites/auctions/components/utils'
import { isAuctionOwner } from '../permissionsutil'
import css from './sass/liveauction.module.scss'
import UserFullHistoryTable from './UserFullHistoryTable'

import { formatMoney } from 'services/util'

export default function AuctionRegistrationRow( {registration, auctionDetail, toAttendeePage} ) {
  // make sure to update copyAttendeesToClipboard in LiveAttendeeView if these columns change

    //formatting for user bid history table
  const user = {
    UserId: registration.User.UserId,
    FullName: registration.FullName,
  }

  const auctionOwner = isAuctionOwner(auctionDetail)

  const TransactionCell = function(options) {
    const {giftStatus, transactionId, index} = options
    return (
      <>
         {index > 0 ? ', ' : ''}
         {giftStatus === 'adminMarkedPaid' ? <b>{transactionId}</b> : <><b>{giftStatus}</b>: {transactionId}</>}
      </>
    )
  }

  const transactionFormatting = () => {
    // if transactions are not attached, return nothing to have a blank response for the auctions that haven't ended yet
    if (!registration.Transactions) return
    
    if (Object.keys(registration.Transactions).length === 0) return <td></td>

    // TO DO ? it seems like if an admin goes in and marks something as paid, then the user pays for the rest of the transaction...
    // the transactions only show up as being marked by admin
    // if the admins start to request anything about the transaction ids, we will need to address this
    
    return <td>
      {Object.keys(registration.Transactions).map((giftStatus, index) => {
        return (
          <TransactionCell key={index} giftStatus={giftStatus} transactionId={registration.Transactions[giftStatus]} index={index}/>
        )})}
      </td>
  }

  const dueFormatting = () => {
    if (registration.TotalDue === '0') return <td>${registration.TotalDue}</td>
    else return <td className={css['manage-checkout']}>
      <p>
        ${formatMoney(registration.TotalDue)}
        </p>
      {auctionOwner && <p onClick={() =>toAttendeePage(registration)}>Manage Checkout</p>}
      </td>
  }

  
  return (
    <tr>
      <td> <UserFullHistoryTable user ={user} auctionDetail={auctionDetail} /> </td>
      {registration.TotalDue && dueFormatting()}
      {registration.TotalPaid && <td>${formatMoney(registration.TotalPaid)}</td>}
      {registration.ItemsWon && <td>{registration.ItemsWon}</td>}
      {registration.BidCount && <td>{formatMoney(registration.BidCount)}</td>} 
      {registration.TotalAmount && <td>${formatMoney(registration.TotalAmount)}</td>}
      {auctionDetail?.NeedsCheckin && <td>{registration.CheckStr}</td>}
      {auctionOwner &&
        <>
        <td>{registration.EmailStr}</td>
        <td>{registration.CrmId}</td>
        <td>{registration.PhoneStr}</td>
        </>
        }
      <td>{registration.RegDate}</td>
      {transactionFormatting()}
    </tr>
  )
}
